import { styled } from 'linaria/react';

export const MeasurementBannerTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-100);

  @media (--only-mobile) {
    margin-bottom: auto;
  }
`;

export const MeasurementBannerContainer = styled.div<{ notAlone?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
  width: 306px;
  min-height: 148px;
  height: auto;
  padding: var(--space-200);
  background: var(--service-light);
  border-radius: 12px;

  @media (--only-tablet) {
    justify-content: space-between;
    width: 50%;
  }

  @media (--only-mobile) {
    min-width: 306px;
    width: 306px;
    max-width: 306px;
    height: auto;
    scroll-snap-align: center;
  }

  @media (max-width: 640px) {
    width: ${props => (props.notAlone ? '306px' : '100%')};
    max-width: ${props => (props.notAlone ? '306px' : '100%')};
  }
`;

export const MeasurementBannersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-300);

  @media (--only-tablet) {
    flex-direction: row;
  }
  @media (--only-mobile) {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: var(--space-200);
    height: auto;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
  }
`;

export const SelfMeasurementBannerContainer = styled(MeasurementBannerContainer)`
  margin-top: 0;
  background: var(--secondary-purple-light);
`;
